// extracted by mini-css-extract-plugin
module.exports = {"container":"DamageTypesTab_container__2vdbE"};